// Lightweight — only validates icon codes and exposes the BEIconCode type.
// The actual FontAwesome SVG definitions live in iconRegistry.ts, which
// is loaded only by the lazy `icons` chunk via FontAwesomeWrapper.
import { AMENITY_CODES } from '@data/types/Amenity';
import { LEGACY_AMENITY_CODES, } from '@data/types/LegacyAmenity';
import { APP_ICON_CODES } from './icons/appIconCodes';
const BE_ICON_CODES = new Set([
    ...APP_ICON_CODES,
    ...AMENITY_CODES,
    ...LEGACY_AMENITY_CODES,
]);
export const isBEIcon = (name) => typeof name === 'string' && BE_ICON_CODES.has(name);
export const isAmenityIcon = (name) => AMENITY_CODES.includes(name) ||
    LEGACY_AMENITY_CODES.includes(name);
